module.exports = __webpack_public_path__ + "static/img/15.89f6bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/15.png
// module id = 7AXW
// module chunks = 0